import {
  Component,
  Output,
  EventEmitter,
  Input,
  HostListener,
  AfterViewInit,
  OnChanges,
  ViewChild,
  ElementRef,
  SimpleChanges,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { EmojiEvent, EmojiService } from "@ctrl/ngx-emoji-mart/ngx-emoji";
import { PickerComponent } from "@ctrl/ngx-emoji-mart";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { DxPopupModule } from "devextreme-angular";

@Component({
    selector: "app-emoji-picker",
    imports: [CommonModule, PickerComponent, SvgIconComponent, DxPopupModule],
    templateUrl: "./emoji-picker.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./emoji-picker.component.css"
})
export class EmojiPickerComponent implements OnChanges, OnInit {
  pickerVisible = false;
  isHiding = false;

  @Input() selectedEmoji: string | null = null; // Track which emoji is selected
  @Output() emojiSelected = new EventEmitter<string>();

  @ViewChild("emojiPicker", { static: false })
  emojiPicker!: any;

  constructor(private emojiService: EmojiService) {}

  togglePicker() {
    this.pickerVisible = !this.pickerVisible;
  }

  addEmoji(event: EmojiEvent) {
    this.emojiSelected.emit(event.emoji.id);
    this.pickerVisible = false;
  }
  ngOnInit(): void {
    this.updateSelectedEmoji();
  }

  ngOnChanges(change: SimpleChanges) {
    if (change.selectedEmoji) {
      this.updateSelectedEmoji();
    }
  }

  updateSelectedEmoji() {
    if (!this.selectedEmoji) return;

    // Remove previous selected class
    const previousSelected = document.querySelectorAll(
      ".emoji-mart-emoji.selected"
    );
    previousSelected.forEach((element) => {
      element.classList.remove("selected");
    });

    const emojiPicker = document.querySelector(".emoji-picker");
    const emoji = this.emojiService.getData(this.selectedEmoji);

    emojiPicker
      .querySelectorAll(
        ".emoji-mart-emoji[aria-label='" +
          emoji.native +
          ", " +
          emoji.shortNames.join(", ") +
          "']"
      )
      .forEach((element: any) => {
        element.classList.add("selected");
      });
  }
}
